// File generated by MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
import { FiltersDto , FiltersDtoFormGroup } from '../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/FiltersDto';
import { BankSimpleDto } from './BankSimpleDto';
import { BankBranchDto } from './BankBranchDto';

export class BankAccountFiltersDto extends FiltersDto {
  id: string | null = null;
  holderId: string | null = null;
  bankId: string | null = null;
  bank: BankSimpleDto;
  accountTypeList: number[] = [];
  accountNumber: string = '';
  bankBranchId: string | null = null;
  bankBranch: BankBranchDto;
  currencyList: number[] = [];
  isVerified: boolean | null = null;
  personType: number | null = null;
  holderName: string = '';
  bankAccountIdList: string[] = [];
  includeAuthorized: boolean | null = null;
}

export interface BankAccountFiltersDtoFormGroup extends FiltersDtoFormGroup {
  id?: any;
  holderId?: any;
  bankId?: any;
  bank?: any;
  accountTypeList?: any;
  accountNumber?: any;
  bankBranchId?: any;
  bankBranch?: any;
  currencyList?: any;
  isVerified?: any;
  personType?: any;
  holderName?: any;
  bankAccountIdList?: any;
  includeAuthorized?: any;
}
